import { setCurrentPage } from '../redux/userSlice';

const setPageAndDeferNavigate = (dispatch, path, navigateFn, delay = 100) => {
    dispatch(setCurrentPage(path));
    setTimeout(() => {
        if (typeof navigateFn === 'function') {
            navigateFn(path);
        }
    }, delay);
};

export default setPageAndDeferNavigate;